import { render } from "./TeamCard.vue?vue&type=template&id=02c751b1"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__